export {
  addFavoriteChannel as requestAddFavoriteChannel,
  deleteFavoriteChannel as requestDeleteFavoriteChannel,
  fetchFavoriteChannels as fetchFavoriteDictionary,
} from '../../phoenix';
